export default __webpack_public_path__ + "static/media/1846.336a9256.png";